export default String.raw`
{% if include -%}
    {% assign orderStep = include -%}
{% endif -%}
{% assign vatValue = cart.VATValue -%}
{% assign deliveryCost = cart.SelectedDelivery.TotalValue -%}
{% assign paymentCost = cart.SelectedDelivery.Payment.TotalValue -%}
{% assign notDeterminedDeliveryCost = cart.SelectedDelivery.NotDeterminedDeliveryCost -%}

<div class="cart__summary cart-hide-summary cart-summary-js replace-with-js">
    {% if cart.NotDeterminedDeliveryCost or cart.SelectedDelivery.NotDeterminedDeliveryCost -%}
        {% assign notDeterminedDeliveryCost = true -%}
    {% endif -%}

    <div class="cart__summary-row strong pb">{{ translations.Summary }}</div>
    {% if settings.loyaltyProgram == "yes" and orderStep == 'Third' -%}
        {% if cart.Points != null and cart.Coupon == null -%}
            {% capture points -%} <strong>{{ cart.Points | ToString }}</strong> {% endcapture -%}
            <div class="cart__loyalty-summary">
                <svg>
                    <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#award-{{settings.iconStyle}}'></use>
                </svg>
                {% if usr.Authenticated -%}
                    <p>{{ translations.LoyaltyPointsForOrder | Format: points }} <strong>{{ translations.PointsShortcut }}</strong>.</p>
                {% else -%}
                    <p>{{ translations.LoyaltyInfoForNotLogged | Format: points }}</p>
                {% endif -%}
            </div>
        {% endif -%}
    {% endif -%}

    {% if orderStep == 'First' -%}
        {% unless customer.Cart.Inquiry -%}
            {% if customer.Points > 0 -%}
                {% if cart.ProductsMinimumTotalValue == null or cart.ProductsTotalValue > cart.ProductsMinimumTotalValue -%}
                    <div class="cart__points cart-points-js">
                        {% assign pointsToUse = false -%}
                        {% assign pointsUsed = false -%}

                        {% if cart.PointsPrice != null and cart.Coupon == null -%}
                            {% assign pointsToUse = true -%}
                        {% endif -%}

                        {% if cart.PointsPaid != null and cart.Coupon == null -%}
                            {% assign pointsUsed = true -%}
                        {% endif -%}
                        {% if cart.Coupon == null -%}
                            {% if pointsToUse or pointsUsed -%}
                                <label for="show-points" tabindex="0" role="checkbox" {% if pointsToUse -%} aria-checked="false" {% endif -%} class="cart__tos-label">
                                    <input id="show-points" type="checkbox" name="show-points" class="cart-show-points-js" {% if pointsUsed -%} checked disabled {% endif -%}>
                                    <div class="cart__tos-checkbox">
                                        <svg>
                                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                        </svg>
                                    </div>
                                    <div class="cart__tos-consent-label">
                                        {{ translations.PayViaLoyaltyPoints }}
                                    </div>
                                </label>
                                <div class="cart__pay-with-points cart-loyalty-box-js" {% unless pointsUsed -%} style="display: none" {% endunless -%}>
                                    {% if pointsToUse -%}
                                        <div class="cart__pay-with-points--content">
                                            {% capture pointsValueWithCurrency -%} <strong>{{ cart.PointsPriceTotalValue | Round: config.DecimalPlacesPrice | ToPrice }} {{ cart.CurrencyExt }} </strong> {% endcapture -%}
                                            {% capture pointsPrice -%} <strong>{{ cart.PointsPrice | ToString }}</strong> {% endcapture -%}

                                            <span>{{ translations.UsePointsInCart | Format: pointsPrice }}.</span>
                                        </div>
                                        <div class="form-js no-message-js">
                                            <input type="hidden" name="__action" value="Order/PointsUse" />
                                            <button aria-label="{{ translations.PayViaLoyaltyPoints }}" class="secondary-action-button cart-pay-with-points-js enter-key-trigger-js parent-container-reload-js">{{ translations.Apply }}</button>
                                        </div>
                                    {% endif -%}
                                    {% if pointsUsed -%}
                                        <div class="cart__pay-with-points--content">
                                            {% assign pointsPaid = cart.PointsPaid | ToString | Prepend: '<strong>' | Append: '</strong>' -%}
                                            {% capture pointsValueWithCurrency -%} <strong>{{ cart.PointsPriceTotalValue | Round: config.DecimalPlacesPrice | ToPrice }} {{ cart.CurrencyExt }} </strong> {% endcapture -%}
                                            
                                            <span>{{ translations.RemovedLoyaltyPoints | Format: pointsPaid }}.</span>
                                        </div>
                                        <div class="form-js no-message-js">
                                            <input aria-label="{{ translations.Cancel }}" type="hidden" name="__action" value="Cart/Recalculate" />
                                            <button aria-label="{{translations.Cancel}}" class="secondary-action-button post-js parent-container-reload-js cancel-pay-with-points-js">{{ translations.Cancel }}</button>
                                        </div>
                                    {% endif -%}
                                </div>
                            {% endif -%}
                        {% endif -%}
                    </div>
                {% endif -%}
            {% endif -%}
        {% endunless -%}
        {% if cart.PointsPaid == null -%}
            <div class="cart__coupon cart-coupon-js">
                <label for="show-coupon" tabindex="0" role="checkbox" {% if cart.Coupon -%} aria-checked="true" {% else -%} aria-checked="false" {% endif -%} class="cart__tos-label">
                    <input id="show-coupon" type="checkbox" name="show-coupon" {% if cart.Coupon == null -%} class="cart-show-coupon-js" {% endif -%} {% if cart.Coupon -%} checked disabled {% endif -%} >
                    <div class="cart__tos-checkbox">
                        <svg>
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                        </svg>
                    </div>
                    <div class="cart__tos-consent-label">
                        {{ translations.HaveCoupon }}
                    </div>
                </label>
                <div class="cart__coupon-content cart-coupon-box-js" {% if cart.Coupon == null -%} style="display: none" {% endif -%}>
                    {% if cart.Coupon == null -%}
                        <div class="form-js form-into-data-js">
                            <input type="hidden" name="__action" value="Order/CouponAdd" >
                            <div class="cart__coupon-wrapper">
                                <div class="form__input-wrapper">
                                    <label for="code" class="form__input-info input-info-js">{{ translations.DiscountCode }}</label>
                                    <input id="code" type="text" class="form__input-value input-value-js" name="code" maxlength="50">
                                    <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillDiscountCode }}</div>
                                </div>
                                <button aria-label="{{ translations.Apply }}" class="primary-action-button cart__coupon-btn add-coupon-js enter-key-trigger-js parent-container-reload-js">{{ translations.Apply }}</button>
                            </div>
                            {% if customer.Email == '' -%}
                                <div class="form__input-wrapper cart-coupon-email-js hidden-js">
                                    <label for="email" class="form__input-info input-info-js"><span class="required">* </span>{{ translations.Email }}</label>
                                    <input class="form__input-value input-value-js" id="email" type="email" name="email" maxlength="192">
                                    <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillEmail }}</div>
                                    <div class="form__invalid-input validation-info-js email-valid-js hidden-js">{{ translations.FillProperEmail }}</div>
                                </div>
                            {% else -%}
                                <input type="hidden" name="email" value="{{ customer.Email }}" >
                            {% endif -%}
                        </div>
                    {% else -%}
                        <div class="form-js no-message-js container-js">
                            <input type="hidden" name="__action" value="Order/CouponDelete" >
                            <div class="cart__coupon-wrapper">
                                <div class="form__input-wrapper">
                                    <label for="coupon" class="form__input-info input-info-js">{{ translations.DiscountCode }}</label>
                                    <input id="coupon" aria-label="coupon" class="form__input-value input-value-js" type="text" value="{{ cart.Coupon }}" readonly >
                                </div>
                                <button aria-label="{{ translations.Delete }}" class="post-js parent-container-reload-js primary-action-button cart__coupon-btn delete-cart-coupon-js">
                                    {{ translations.Delete }}
                                </button>
                            </div>
                            {% if customer.Email == '' -%}
                                <div class="form__input-wrapper {% if cart.Customer.Email == '' -%} hidden-js {% endif -%}">
                                    <label for="email" class="form__input-info input-info-js">{{ translations.Email }}</label>
                                    <input class="form__input-value input-value-js" id="email" type="email" name="email" value="{{ cart.Customer.Email }}" readonly>
                                </div>
                            {% else -%}
                                <input type="hidden" name="email" value="{{ customer.Email }}" >
                            {% endif -%}
                        </div>
                    {% endif -%}
                </div>
            </div>
        {% endif -%}
    {% endif -%}

    {% if cart.Discount > 0 and settings.discountsPresentationInOrderSummary == 'yes' -%}
        <div class="cart__summary-row">
            <div>
                {{ translations.Value }}
                {% if cart.SubtotalPrices -%}
                    {{ translations.Netto | Downcase }}
                {% else -%}
                    {{ translations.Brutto | Downcase }}
                {% endif -%}
                {{ translations.BeforeDiscount | Downcase }}
            </div>
            <div>{{ cart.ProductsValueBeforeDiscount | ToPrice }} {{ cart.CurrencyExt }}</div>
        </div>

        <div class="cart__summary-row">
            <div>
                {{ translations.Discount }}
            </div>
            <div>{{ cart.Discount | Normalize }} %</div>
        </div>
    {% endif -%}

    {% if config.ENTERPRISE -%}
        <div class="cart__summary-row">
            <div>
                {{ translations.Value }}
                {{ translations.Netto | Downcase }}
            </div>
            <div>
                {{ cart.ProductsSubtotalValue | ToPrice }}
                {{ cart.CurrencyExt }}
            </div>
        </div>
        <div class="cart__summary-row">
            <div>
                {{ translations.Value }}
                {{ translations.Brutto | Downcase }}
            </div>
            <div>
                {{ cart.ProductsTotalValue | ToPrice }}
                {{ cart.CurrencyExt }}
            </div>
        </div>
    {% else -%}
        <div class="cart__summary-row">
            <div>
                {{ translations.Value }}
                {% if cart.SubtotalPrices -%}
                    {{ translations.Netto | Downcase }}
                {% else -%}
                    {{ translations.Brutto | Downcase }}
                {% endif -%}
            </div>
            <div>
                {% if cart.SubtotalPrices -%}
                    {{ cart.ProductsSubtotalValue | ToPrice }}
                {% else -%}
                    {{ cart.ProductsTotalValue | ToPrice }}
                {% endif -%}
                {{ cart.CurrencyExt }}
            </div>
        </div>
    {% endif -%}

    <div class="cart__summary-row">
        {% if config.ENTERPRISE or cart.SubtotalPrices -%}
            <div>{{ translations.VatValue }}</div>
        {% else -%}
            <div>{{ translations.VatIncluded }}</div>
        {% endif -%}
        <div>{{ vatValue | ToPrice }} {{ cart.CurrencyExt }}</div>
    </div>

    {% if cart.NotDeterminedDeliveryCost == false and notDeterminedDeliveryCost == false -%}
        <div class="cart__summary-row">
            <div>{{ translations.DelivCost }}</div>
	        <div>{{ deliveryCost | ToPrice }} {{ cart.CurrencyExt }}</div>
        </div>
    {% endif -%}

    {% if paymentCost != null and cart.NotDeterminedDeliveryCost == false and notDeterminedDeliveryCost == false -%}
        <div class="cart__summary-row">
            <div>{{ translations.PaymentCost }}</div>
            <div>{{ paymentCost | ToPrice }} {{ cart.CurrencyExt }}</div>
        </div>
    {% endif -%}

    {% if cart.TotalDepositValue > 0 -%}
        <div class="cart__summary-row">
            <div>{{ translations.Com_Deposit }}</div>
            <div>{{ cart.TotalDepositValue | ToPrice: config.DecimalPlacesPrice }} {{ cart.CurrencyExt }}</div>
        </div>
    {% endif -%}

    <div class="cart__summary-row strong pt">
        <div>{{ translations.AmountDue }}</div>
        <div>{{ cart.OrderTotalValue | ToPrice }} {{ cart.CurrencyExt }}</div>
    </div>

    {% if orderStep == 'Third' -%}
        <div class="form-js adding-order-form-js cart__consents cart-consents-js">
            <div class='form__required-fields'><span class='required'>*</span> {{ translations.RequiredFields }}</div>
            <input type="hidden" name="__action" value="Order/Add" >

            {% for tos in config.TOS.Consents.Order -%}
                {% assign channelsSize = tos.Channels | Size -%}
                {% if channelsSize > 0 -%}
                    {% assign onlyEmail = false -%}
                    {% if channelsSize == 1 and tos.Channels[0].Type == 1 -%}
                        {% assign onlyEmail = true -%}
                    {% endif -%}
                    {% if onlyEmail == false -%}
                        <div class="cart__tos-error validation-info-js validation-channel-js hidden-js">{{ translations.ChooseOption }}</div>
                    {% endif -%}
                {% endif -%}
                <div class="cart__tos-consent tos-container-js {% if tos.Statement -%} statement-js {% endif -%}" >
                    {% if tos.Statement -%}
                        {% unless channelsSize == 1 -%}
                            <div>{% if tos.Required-%}<span class="cart__tos-required">* </span>{% endif -%} {{tos.Text | Replace: '\.', ' ' }}{% if channelsSize > 0 -%} {{translations.Consents_InTheFormOf}}:{% endif -%}</div>
                        {% endunless -%}
                    {% else -%}
                        <label {% unless channelsSize > 0 -%} tabindex="0" role="checkbox" {% endunless -%} class="cart__tos-label tos-js">
                            {% if channelsSize == 1 -%}
                                <input aria-label="tos" type="checkbox" name="tos" value="{{ tos.Id }}" {% if tos.Required -%} required {% endif -%} >
                            {% elsif channelsSize > 0 -%}
                                <input aria-label="tos" type="checkbox" name="tos" value="{{ tos.Id }}" {% if tos.Required -%} required {% endif -%} >
                                {% if tos.Required-%}<span class="cart__tos-required">* </span>{% endif -%} {{tos.Text | Remove: '.' }} {{translations.Consents_InTheFormOf}}:
                                {% if tos.Required -%}
                                    <div class="cart__tos-error validation-info-js validation-required-js hidden-js">{{ translations.RequiredField }}</div>
                                {% endif -%}
                            {% else -%}
                                <input  aria-label="tos" type="checkbox" name="tos" value="{{ tos.Id }}" {% if tos.Required -%} required {% endif -%} >
                                <div class="cart__tos-checkbox">
                                    <svg>
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                    </svg>
                                </div>
                                <div class="cart__tos-consent-label">
                                    {% if tos.Required -%}<span class="cart__tos-required">*</span> {% endif -%}{{ tos.Text }}
                                </div>
                                {% if tos.Required -%}
                                    <div class="cart__tos-error validation-info-js validation-required-js hidden-js">{{ translations.RequiredField }}</div>
                                {% endif -%}
                            {% endif -%}
                        </label>
                    {% endif -%}
                    {% if channelsSize > 0 -%}
                        {% if onlyEmail == false -%}
                            <div class="cart__tos-error validation-info-js validation-channel-js hidden-js">{{ translations.ChooseOption }}</div>
                        {% endif -%}
                    {% endif -%}
                    {% for channel in tos.Channels -%}
                        <label tabindex="0" role="checkbox" {% if tos.Statement -%} aria-checked="true" {% else -%} aria-checked="false" {% endif -%} class="cart__tos-label {% if channelsSize > 0 -%} channel-js {% endif -%}">
                            {% if tos.Statement -%}
                                {% if channelsSize == 1 -%}
                                    <input type="hidden" name="channelKey" value="{{ channel.Key }}" checked >
                                    <input aria-label="channelKey" type="checkbox" checked disabled >
                                    <div class="cart__tos-checkbox">
                                        <svg>
                                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                        </svg>
                                    </div>
                                    <div>{% if tos.Required-%}<span class="cart__tos-required">* </span>{% endif -%} {{tos.Text | Remove: '.' }} {{translations.Consents_InTheFormOf}} {% unless channel.Name == "SMS" -%} {{ channel.Name | Downcase }}. {% else -%} {{ channel.Name }}. {% endunless -%}</div>
                                {% elsif channelsSize > 0 -%}
                                    <input aria-label="channelKey" type="checkbox" name="channelKey" value="{{ channel.Key }}" checked >
                                    <div class="cart__tos-checkbox">
                                        <svg>
                                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                        </svg>
                                    </div>
                                    <div>{{ channel.Name }}</div>
                                {% endif -%}
                            {% else -%}
                                {% if channelsSize == 1 -%}
                                    <input aria-label="channelKey" type="checkbox" name="channelKey" value="{{ channel.Key }}" >
                                    <div class="cart__tos-checkbox">
                                        <svg>
                                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                        </svg>
                                    </div>
                                    <div class="cart__tos-consent-label">
                                        {% if tos.Required-%}<span class="cart__tos-required">* </span>{% endif -%} {{tos.Text | Remove: '.' }} {{translations.Consents_InTheFormOf}} {% unless channel.Name == "SMS" -%} {{ channel.Name | Downcase }}. {% else -%} {{ channel.Name }}. {% endunless -%}
                                    </div>
                                {% elsif channelsSize > 0 -%}
                                    <input aria-label="channelKey" type="checkbox" name="channelKey" value="{{ channel.Key }}" >
                                    <div class="cart__tos-checkbox">
                                        <svg>
                                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                        </svg>
                                    </div>
                                    <div class="cart__tos-consent-label">{{ channel.Name }}</div>
                                {% endif -%}
                            {% endif -%}
                        </label>
                    {% endfor -%}
                </div>
            {% endfor -%}

            {% if customer.CreditLimit and creditStatus == 2 -%}
                <div class="cart__info-bar warning-bar">{{ translations.CreditLimitStatus_2 }}</div>
            {% elsif customer.CreditLimit and creditStatus == 1 -%}
                <div class="cart__info-bar warning-bar">{{ translations.CreditLimitStatus_1 }}</div>
            {% endif -%}
        </div>

        <button 
                class="cart__order-button primary-action-button add-order-js" 
                {% if creditStatus == 2 or disableOrderButton or include -%} disabled {% endif -%} 
                data-container=".order-template-js"
        >
            {{translations.PayAndOrder}}
        </button>
    {% endif -%}
</div>

`